<template>

    <div class="container">

        <app-head :title="__('Suche nach \':term\'', {term: search})" />

        <div class="my-4">
            <!--<breadcrumbs />-->
            <h1>Suchergebnisse für "{{ search }}"</h1>
        </div>

        <div class="my-5">
            <filters :filters="filters"
                     :supplier-options="supplierOptions"
                     :manufacturer-options="manufacturerOptions"
                     :payment-method-options="paymentMethodOptions"
                     :brand-options="brandOptions"
                     :min-price="minPrice"
                     :max-price="maxPrice"
                     />
        </div>

        <results :total="total" :filters="filters" @loading="setLoading" />

        <product-list :products="products.data" :loading="loading" />

        <pagination :links="links" />

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Filters from '@/shared/Filters';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import Pagination from '@/shared/Pagination';
    import ProductList from '@/shared/ProductList';

    export default {
        props: [
            'search',
            'total',
            'links',
            'products',
            'filters',
            'supplierOptions',
            'manufacturerOptions',
            'brandOptions',
            'paymentMethodOptions',
            'minPrice',
            'maxPrice',
        ],
        data() {
            return {
                loading: false
            }
        },
        mixins: [
        ],
        components: {
            Results,
            Filters,
            Breadcrumbs,
            Pagination,
            ProductList,
        },
        watch: {
        },
        methods: {
            setLoading(bool) {
                this.loading = bool;
            }
        },
    }
</script>